import React from 'react';
import {
  Button,
} from 'web-components';

import Exercise from './Exercise';
import * as S from './styled';

type Props = {
  event: Object,
  exercises: Array<Object>,
  onFinished: { (): void },
  onRemoveAll: { (): void },
};

export default ({
  event,
  exercises,
  onFinished,
  onRemoveAll,
}: Props) => (
  <S.Exercises>
    {exercises?.map(item => (
      <Exercise
        key={item.id}
        event={event}
        exercise={item}
      />
    ))}
    <S.ButtonsGroup>
      <Button
        ghost
        appearance="danger"
        onClick={onRemoveAll}
      >
        Remove all results
      </Button>
      <Button
        ghost
        appearance="primary"
        onClick={onFinished}
      >
        Finished
      </Button>
    </S.ButtonsGroup>
  </S.Exercises>
);
